import React from "react";
import { Link, useLocation } from "react-router-dom";
import tools from "../../images/tools.svg";
import home from "../../images/home.svg";
import split from "../../images/split.svg";
import messages from "../../images/messages.svg";

const navLinks = [
  { to: "/coach/dashboard", icon: home, label: "Dashboard" },
  { to: "/coach/mysplit", icon: split, label: "MySplit" },
  { to: "/coach/tools", icon: tools, label: "Tools" },
  { to: "#", icon: messages, label: "Messages" },
];

export const CoachFooter = () => {
  const location = useLocation();

  return (
    // <div className="sticky bottom-0">
    <div className="w-full max-w-[560px] mx-auto flex justify-between items-center max-[350px]:gap-2 gap-10 px-5 pt-2 pb-1">
      {navLinks.map(({ to, icon, label }) => (
        <Link
          key={to}
          to={to}
          className={`flex flex-col justify-between items-center gap-[10px] group`}
        >
          <img
            src={icon}
            alt={label}
            className="object-contain w-full max-w-6 h-7"
          />
          <span
            className={`text-[11px] tracking-[0.66px] capitalize text-black font-bold ${
              location.pathname === to ? "opacity-100" : "opacity-40"
            } group-hover:opacity-90 transition-all`}
          >
            {label}
          </span>
        </Link>
      ))}
    </div>
    // </div>
  );
};
